import Vue from 'vue'
import Router from 'vue-router'
import shaanxi from './shaanxi.route'
import liaoning from './liaoning.route'
import chongqing from './chongqing.route'
import sichuan from './sichuan.route'
import xinjiang from './xinjiang.route'
import ningxia from './ningxia.route'
import language from './language.route'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/redirect'
    },
    {
      path: '/success',
      name: "commonSuccessShowAD",
      component: () => import('@/views/common/success.vue'),
      meta: {
        title: '办理成功'
      }
    },
    {
      path: '/redirect',
      name: "commonRedirect",
      component: () => import('@/views/common/redirect.vue'),
      meta: {
        title: '页面跳转中...'
      }
    },
    ...shaanxi,
    ...liaoning,
    ...chongqing,
    ...sichuan,
    ...xinjiang,
    ...ningxia,
    ...language
  ]
})
